module.exports = __webpack_public_path__ + "img/a-1.93a73e69.jpg";